import React from 'react';

import { FormLine, FormType, FormErrorType } from './FormLine';

interface FormProps {
  formLineData: Record<string, any>;
  event: Record<string, any>;
  merge: Record<string, any>;
  isJukiCardSelected?: boolean;
  notGuardian?: boolean;
}

const Form: React.FC<FormProps> = ({
  formLineData = {},
  event = {},
  merge = {},
  isJukiCardSelected,
  notGuardian,
}) => {
  return (
    <React.Fragment>
      {Object.entries(formLineData).map((item) => {
        const dataSource = { ...merge, ...event, ...item[1], key: item[0] };
        if (item[0] === 'idCard' && isJukiCardSelected) {
          return <div key={item[0]} />;
        }
        if (item[0] === 'expirationDate') {
          return (
            <FormLine
              key={item[0]}
              dataSource={dataSource}
              notGuardian={notGuardian}
            />
          );
        }
        if (item[0].startsWith('position')) {
          return <FormLine key={item[0]} dataSource={dataSource} isOptional />;
        }
        return <FormLine key={item[0]} dataSource={dataSource} />;
      })}
    </React.Fragment>
  );
};

/**
 * 将数据源模板 转换为 FormLine使用的数据
 * @param template  模板文件 是个数组
 */
Form.conversion = (template: any[]) => {
  const newTemp: any[] = [];
  template.forEach((templateItem) => {
    const formTemplate: Record<string, any> = {};
    Object.entries(templateItem.form).forEach((item) => {
      // formLine的key
      const key = item[0];
      // 原始数据模板的一项
      const content = item[1];

      const {
        title,
        subTitle,
        pop,
        input,
        required,
        list,
        hidden,
        extend,
        cleanValue,
        bottomTips,
        bottomArea,
        rightArea,
        editable,
        noWheelEvent,
        ...contentOtherAttr
      } = content;
      // 每一行的formLine最终的数据，下方为共有部分
      let itemData: any = {
        formType: content.formType,
        title,
        subTitle,
        pop,
        list,
        hidden,
        extend,
        required,
        cleanValue, // 清除值标志位
        bottomTips,
        bottomArea,
        rightArea,
        editable,
        noWheelEvent,
        errorData: content.errorData,
      };

      // 一行多输入的情况下
      if (
        content.formType === FormType.MULTI_INPUT ||
        content.formType === FormType.CARD
      ) {
        const inputList: any[] = [];

        // 循环 input数组
        input.forEach((inputItem: any) => {
          const {
            formType,
            placeholderRight,
            placeholderLeft,
            value,
            errorData,
            id,
            cardTitle,
            ...attr
          } = inputItem;

          inputList.push({
            key: inputItem.key,
            formType,
            placeholderRight,
            placeholderLeft,
            value,
            id,
            cardTitle,
            list: inputItem.list,
            inputAttr: { ...attr },
            errorData, // 每个输入框各自独特的错误
          });
        });
        itemData.inputList = inputList;
      } else if (content.formType === FormType.UPLOAD) {
        itemData.inputList = input;
        itemData = Object.assign(itemData, { ...contentOtherAttr });
      } else {
        const { formType, placeholderLeft, placeholderRight, value, ...attr } =
          input[0];
        itemData.inputAttr = { ...attr };
        itemData.placeholderRight = placeholderRight;
        itemData.placeholderLeft = placeholderLeft;
        itemData.value = value;
      }
      if (content.formType === FormType.SELECT) {
        itemData.list = list;
      }
      formTemplate[key] = itemData;
    });
    newTemp.push({
      title: templateItem.title,
      subTitle: templateItem.subTitle,
      link: templateItem.link,
      linkMessage: templateItem.linkMessage,
      form: formTemplate,
    });
  });
  return newTemp;
};

export { Form, FormLine, FormType, FormErrorType };
